import axios from "axios";

export default axios.create({
  baseURL: "https://restaurant-tiv8.herokuapp.com",
});